import React from "react"

import { DeleteFloorOverlay } from "./DeleteFloorOverlay"
import { useDeleteFloorOverlayModel } from "./model/useDeleteFloorOverlayModel"

export interface DeleteFloorOverlayPayload {
  projectID: string
  floorID: string
}

export interface DeleteFloorOverlayConnectorProps {
  payload: DeleteFloorOverlayPayload
}

export const DeleteFloorOverlayConnector = React.memo(
  (props: DeleteFloorOverlayConnectorProps) => (
    <DeleteFloorOverlay {...useDeleteFloorOverlayModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    DELETE_FLOOR_OVERLAY: DeleteFloorOverlayPayload
  }
}
